module.exports = __webpack_public_path__ + "static/media/light.3466df2b.svg";